const BLOCKED_WORDS = new Set([
	'arsehole',
	'asshole',
	'bastard',
	'bitch',
	'bollocks',
	'bullshit',
	'cock',
	'cunt',
	'dick',
	'dickhead',
	'douche',
	'douchebag',
	'fag',
	'faggot',
	'fuck',
	'fucked',
	'fucker',
	'fucking',
	'jackass',
	'motherfucker',
	'nigga',
	'nigger',
	'piss',
	'prick',
	'pussy',
	'retard',
	'retarded',
	'shit',
	'shitty',
	'slut',
	'twat',
	'wanker',
	'whore',
]);

export const PROFANITY_MESSAGE = 'Please remove inappropriate language and try again.';

export function containsProfanity(text: string | null | undefined): boolean {
	if (!text) return false;
	return text
		.toLowerCase()
		.split(/[^a-z]+/)
		.some((token) => token.length > 0 && BLOCKED_WORDS.has(token));
}
